import { createContext, useContext } from 'react';

/**
 * The element the form scrolls inside.
 *
 * As a page this was the window; inside a modal it is the `.modal-body`. SectionNav's
 * scroll spy and its jump-to-section both need to know which, so the shell publishes a ref
 * to the scrolling element here and the nav reads it.
 *
 * A `null` value means "scroll the window" — the nav falls back to that if the provider is
 * missing, so the components still work outside a modal.
 */
export const ScrollContainerContext = createContext({ current: null });

export const useScrollContainer = () => useContext(ScrollContainerContext);
